window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

import Echo from "laravel-echo"

window.io = require('socket.io-client');

if (typeof io !== 'undefined') {
    window.Echo = new Echo({
        broadcaster: "socket.io",
        host: window.location.host + (window.laravel_echo_port ? ':' + window.laravel_echo_port : ''),
        path: '/socket.io/',
    });
}
